export const ROUTES = {
  systems: {
    tracking: '/systems/tracking',
    permitsPartnership: '/systems/permits-partnership',
  },
  services: {
    maritime: '/services/maritime',
    rail: '/services/rail',
    road: '/services/road',
    airCargo: '/services/air-cargo',
  },
};

export const DASHBOARD_MENU_ROUTE_BY_TITLE = {
  'رهگیری چندوجهی (دریایی/ریلی/جاده‌ای/هوایی)': ROUTES.systems.tracking,
  'مسیرهای اخذ مجوز / مدل‌های مشارکت': ROUTES.systems.permitsPartnership,
  'دریایی': ROUTES.services.maritime,
  'ریلی': ROUTES.services.rail,
  'جاده‌ای': ROUTES.services.road,
  'هوایی (کارگو)': ROUTES.services.airCargo,
};

